/*
 * COPYRIGHT:     Copyright © 2018 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */
export const RIGHT_ALIGN = 'right'
export const LEFT_ALIGN = 'left'
export const VERTICAL_ALIGN = 'vertical'
export const HORIZONTAL_ALIGN = 'horizontal'
